import {
  WorkStationGroupServiceProxy,
  WorkStationRealTimeStatusServiceProxy,
  WorkStationWorkingConditionParamSettingServiceProxy,
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { AlarmStatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import { Observable, BehaviorSubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { getToken } from '@/utils/auth'
export const wsgsp = new WorkStationGroupServiceProxy()
export const wsrtssp = new WorkStationRealTimeStatusServiceProxy()
export const wswcpssp = new WorkStationWorkingConditionParamSettingServiceProxy()
export const tssp = new TenantSettingServiceProxy()
export const assp = new AlarmStatisticsServiceProxy()

const fromWSEvent: <K extends keyof WebSocketEventMap>(ws: WebSocket, event: K) => Observable<WebSocketEventMap[K]> = (
  ws,
  event
) => {
  return new Observable(subscriber => {
    const handler = (e: WebSocketEventMap[typeof event]) => {
      subscriber.next(e)
    }
    ws.addEventListener(event, handler)
    return {
      unsubscribe: () => {
        ws.removeEventListener(event, handler)
      },
    }
  })
}

interface Message {
  command: 'SUBSCRIBE' | 'UNSUBSCRIBE' | 'DATA'
  topic?: string
  data: any
  context: string
}

let instance = null

export class RealtimeWS {
  ws: WebSocket

  open$: Observable<Event>
  message$: Observable<MessageEvent>
  error$: Observable<Event>
  close$: Observable<CloseEvent>

  authentication$$ = new BehaviorSubject(null)
  subscribe$$ = new BehaviorSubject(null)
  data$$ = new BehaviorSubject<{ [name: string]: any }>(null)
  unsubscribe$$ = new BehaviorSubject(null)

  properties$$ = new BehaviorSubject(null)

  loading = new BehaviorSubject(true)

  constructor() {
    if (instance) return instance
    instance = this
  }

  get readyState() {
    return this.ws.readyState
  }

  open() {
    const token = getToken()
    this.ws = new WebSocket(`${REALTIME_WEBSOCKET_URL}/${token}`)

    this.open$ = fromWSEvent(this.ws, 'open')
    this.message$ = fromWSEvent(this.ws, 'message')
    this.error$ = fromWSEvent(this.ws, 'error')
    this.close$ = fromWSEvent(this.ws, 'close')

    this.open$.subscribe(() => {
      // message.success('websocket连接成功')
      setTimeout(() => {
        if (this.loading.value) {
          this.loading.next(false)
        }
      }, 3000)
    })

    this.message$
      .pipe(
        map(msgEv => msgEv.data as string),
        map(data => (data.charAt(0) === '{' ? JSON.parse(data) : data))
      )
      .subscribe(data => {
        switch (data.command) {
          case 'SUBSCRIBE': {
            this.subscribe$$.next(data.data)
            break
          }
          case 'DATA': {
            this.data$$.next(data)
            this.properties$$.next({ ...this.properties$$.value, [data.topic]: data.data.propertyValue })
            if (this.loading.value === true) this.loading.next(false)
            break
          }
          case 'UNSUBSCRIBE': {
            this.unsubscribe$$.next(data.data)
            break
          }
          default:
        }
      })

    this.error$.subscribe(() => {
      // message.error('websocket连接失败')
    })

    this.close$.subscribe(() => {
      // message.info('websocket已关闭')
    })
  }

  close() {
    this.ws.close()
  }

  send(msg: Message) {
    this.ws.send(JSON.stringify(msg))
  }

  subscribe(data = []) {
    this.loading.next(true)
    this.send({
      command: 'SUBSCRIBE',
      data,
      context: String(Date.now()),
    })
  }

  unsubscribe(data = []) {
    this.send({
      command: 'UNSUBSCRIBE',
      data,
      context: String(Date.now()),
    })
  }
}

export const ws = new RealtimeWS()
